import { jsPDF } from 'jspdf'

const imageToPdf = async (imageData, fileName = 'arquivo') => {
  let imgSrc = imageData

  // Se vier um Blob, converte para base64
  if (imageData instanceof Blob) {
    imgSrc = await new Promise((resolve) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.readAsDataURL(imageData)
    })
  }

  // Cria uma imagem temporária para pegar dimensões reais
  const img = new window.Image()
  img.src = imgSrc

  await new Promise((resolve) => {
    img.onload = () => resolve()
  })

  // Conversão de pixels para mm (1px ≈ 0.264583 mm)
  const pxToMm = (px) => px * 0.264583

  const imgWidthMm = pxToMm(img.width)
  const imgHeightMm = pxToMm(img.height)

  // Cria PDF com o mesmo tamanho da imagem
  const pdf = new jsPDF({
    orientation: imgWidthMm > imgHeightMm ? 'landscape' : 'portrait',
    unit: 'mm',
    format: [imgWidthMm, imgHeightMm],
  })

  pdf.addImage(imgSrc, 'PNG', 0, 0, imgWidthMm, imgHeightMm, undefined, 'FAST')
  pdf.save(`${fileName}.pdf`)
}

export default imageToPdf
